import { render, staticRenderFns } from "./ProductionBigScreen.vue?vue&type=template&id=5e7dfd27&scoped=true&"
import script from "./ProductionBigScreen.vue?vue&type=script&lang=js&"
export * from "./ProductionBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBigScreen.vue?vue&type=style&index=0&id=5e7dfd27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7dfd27",
  null
  
)

export default component.exports